
const state = {
  error: false,
  customMessage: null,
  errorCode: null,
  completeError: null,
  notification: null,
};

const getters = {
  getError: state => ({
    error: state.error,
    code: state.errorCode,
    customMessage: state.customMessage,
  }),
};

const actions = {
  setError({ commit }, { error, customMessage }) {
    // Custom error messages
    if (customMessage) {
      const { code, completeError } = error;
      commit('SetError', { code, completeError, customMessage });
      setTimeout(() => {
        commit('RemoveError');
      }, 500);

      return;
    }

    // No custom error message, usually means unknown error. Try to construct something sensible.
    const err = {};
    if (typeof error === 'string') err.code = error;
    else if (error.code) err.code = error.code;
    else if (error.msg) err.code = error.msg;
    else if (error.message) err.code = error.message;
    else if (error.response && error.response.data && !error.response.data.code && error.response.data.msg) err.code = error.response.data.msg;
    else if (error.response && error.response.data && !error.response.data.code && error.response.data.message) err.code = error.response.data.message;
    else if (error.response && error.response.data && error.response.data.code) err.code = error.response.data.code;
    else err.code = error;
    // to do: figure out what errors you can get here. Some errors get send here as regular object instead of error object (e.g. 404 errors from b-e API)

    err.completeError = error;

    commit('SetError', err);
    setTimeout(() => {
      commit('RemoveError');
    }, 500);
  },
  setNotification({ commit }, message) {
    commit('SetNotification', message);
    // Remove the notification, else the watcher in AppView will not be triggered upon a new notification with the same message
    setTimeout(() => {
      commit('RemoveNotification');
    }, 500);
  },
};

const mutations = {
  SetError(state, { code, completeError, customMessage }) {
    state.error = true;
    state.customMessage = customMessage;
    state.errorCode = code;
    state.completeError = completeError;
  },
  RemoveError(state) {
    state.error = false;
    state.completeError = null;
  },
  SetNotification(state, message) {
    state.notification = message;
  },
  RemoveNotification(state) {
    state.notification = null;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
